// jQueryの"$"を使えるようにする
// import $ from 'jquery'

// TweenMax
// import TweenMax from 'gsap'

// ScrollMagic
// import ScrollMagic from 'scrollmagic'

// ScrollMagicのgsapプラグイン（要imports-loader）
// import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap'

// jQuery easing
import 'jquery.easing'

//////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////

// ページトップへ戻る
// import pagetop from './modules/pagetop'
// pagetop()

// import spNavi from './modules/sp-navi'
// spNavi()
import navi from './modules/navi'
navi()

import anchorLink from './modules/anchor-link'
anchorLink()

// import accordion from './modules/accordion-collapse'
// accordion()

// import gnaviActive from './modules/gnavi-active'
// gnaviActive()

// import Vue from 'vue'
// import Vue2TouchEvents from 'vue2-touch-events'
// import VueScrollTo from 'vue-scrollto'
// require('es6-object-assign').polyfill()

// Vue.use(Vue2TouchEvents)

// let offset = 80

// Vue.use(VueScrollTo, {
//   duration: 1000,
//   easing: [0.24, 1, 0.32, 1],
//   offset: -offset
// })

// new Vue({
//   el: '#app',
//   data() {
//     return {
//       naviShow: false
//     }
//   },
//   methods: {
//     naviToggle() {
//       this.naviShow = !this.naviShow
//     },
//     naviClose() {
//       if (this.naviShow) {
//         this.naviShow = false
//       }
//     },
//     hoge() {
//       console.log('hoge')
//     }
//   },
//   mounted() {
//     console.log('mounted')
//   }
// })



// WEBPACK FOOTER //
// ./src/js/main.js